import React, { useEffect, useState } from 'react';
import {
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Form,
    FormGroup,
    Label,
    Input,
} from 'reactstrap';
import { useDispatch } from 'react-redux';
import { actions } from '../../../context';
import moment from 'moment-timezone';
import { Facebook } from 'react-spinners-css';
import SuccessConfirmationModal from '../SuccessConfirmationModal';

const EditMissionControlVersionModal = (props) => {
    const {
        isOpen,
        closeBehavior,
        currentMissionControlVersion,
        refreshBehavior,
        saveBehavior,
    } = props;

    const dispatch = useDispatch();

    const [isLoadingVersions, setIsLoadingVersions] = useState(false);
    const [isAwaitingResponse, setIsAwaitingResponse] = useState(false);
    const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
    const [successResponse, setSuccessResponse] = useState({});

    const [missionControlVersions, setMissionControlVersions] = useState([]);
    const [selectedMissionControlVersion, setSelectedMissionControlVersion] =
        useState(currentMissionControlVersion);
    const [hasSelectedVersionChanged, setHasSelectedVersionChanged] =
        useState(false);

    useEffect(() => {
        setIsLoadingVersions(true);
        setSelectedMissionControlVersion(currentMissionControlVersion);
        dispatch(actions.missionControl.fetchMissionControlVersions()).then(
            (res) => {
                setMissionControlVersions(Array.isArray(res) ? res : []);
                setIsLoadingVersions(false);
            }
        );
    }, [dispatch, isOpen]);

    const handleSelectedVersionChange = (e) => {
        setSelectedMissionControlVersion(e.target.value);
        setHasSelectedVersionChanged(
            e.target.value !== currentMissionControlVersion
        );
    };

    const closeModal = () => {
        setSelectedMissionControlVersion('');
        setHasSelectedVersionChanged(false);
        closeBehavior();
    };

    const saveChanges = async () => {
        setIsAwaitingResponse(true);
        saveBehavior(selectedMissionControlVersion)
            .then((res) => {
                console.log(res);
                setSuccessResponse(res);
                refreshBehavior();
            })
            .then(() => {
                setIsAwaitingResponse(false);
                setIsSuccessModalOpen(true);
                closeModal();
            });
    };

    return (
        <>
            <SuccessConfirmationModal
                isOpen={isSuccessModalOpen}
                closeBehavior={() => setIsSuccessModalOpen(false)}
                successResponse={successResponse}
            />
            <Modal isOpen={isOpen} centered className="text-light">
                <ModalHeader>Edit Mission Control Version</ModalHeader>
                <ModalBody>
                    {isLoadingVersions ? (
                        <h2 className="m-4 text-center">
                            <Facebook color="#eee" />
                        </h2>
                    ) : (
                        <Form>
                            <FormGroup>
                                <Label for="missionControlVersion">
                                    Mission Control Version:{' '}
                                    </Label>
                                    
                                <Input
                                    type="select"
                                    name="missionControlVersion"
                                    defaultValue={currentMissionControlVersion}
                                    onChange={handleSelectedVersionChange}
                                    {...(hasSelectedVersionChanged && {
                                        style: {
                                            backgroundColor: 'var(--yellow)',
                                        },
                                    })}>
                                    {(missionControlVersions ?? [])
                                        .filter(
                                            (version) => !version.isInactive
                                        )
                                        .map((version) => (
                                            <option
                                                key={version.version}
                                                value={version.version}>
                                                {getMissionControlVersionDetails(
                                                    version
                                                )}
                                            </option>
                                        ))}
                                </Input> 
                            </FormGroup>
                        </Form>
                    )}
                </ModalBody>
                <ModalFooter>
                    <Button
                        color="secondary"
                        disabled={isAwaitingResponse}
                        onClick={() => closeModal()}>
                        Cancel
                    </Button>
                    <Button
                        color={isAwaitingResponse ? 'secondary' : 'primary'}
                        disabled={isAwaitingResponse}
                        onClick={() => saveChanges()}>
                        {isAwaitingResponse ? 'Saving...' : 'Save'}
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    );
};

export default EditMissionControlVersionModal;

function getMissionControlVersionDetails(version) {
    return `${version.isDefault ? '(Default)' : ''}${version.version} - ${
        version.description === null || version.description === ''
            ? 'No description'
            : version.description
    } (Released: ${moment
        .utc(version.releaseDate)
        .local()
        .format('M/D/YYYY LT')})`;
}
